/*global _LTracker*/
import isStorybook from './env/isStorybook'
import isTest from './env/isTest'

class MockTracker {
  _events = []

  getEvents() {
    return this._events
  }

  push(data) {
    this._events.push(data)
  }
}

class Loggly {
  meta = {}
  init(meta = {}) {
    this.meta = { ...this.meta, ...meta }

    if (isTest() || isStorybook() || !window._LTracker) {
      window._LTracker = new MockTracker()
    }
  }
  info(info) {
    if (!window._LTracker) {
      this.init()
    }
    _LTracker.push({ ...this.meta, ...info, type: 'info' })
  }
  error(err) {
    if (!window._LTracker) {
      this.init()
    }
    _LTracker.push({ ...this.meta, ...err, type: 'error' })
  }
}

export default new Loggly()
